import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import './lib/sentry';

import React from 'react';
import App from './App';
import { ThemeProvider } from './components/providers/theme-provider';
import './index.css';
import { Toaster } from './components/ui/sonner';

const { VITE_ENV } = import.meta.env;

console.log('ENVIRONMENT', VITE_ENV, import.meta.env.MODE);

const container = document.getElementById('root')!;
const root = createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="dark" storageKey="featurebuddy-ui-theme">
      <App />
      <Toaster />
    </ThemeProvider>
  </React.StrictMode>,
);
